import { render, staticRenderFns } from "./QuotaList.vue?vue&type=template&id=d9d19e8e&scoped=true"
import script from "./QuotaList.vue?vue&type=script&lang=js"
export * from "./QuotaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9d19e8e",
  null
  
)

export default component.exports